module.exports = __webpack_public_path__ + "img/ZIM.6c40148b.png";